import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { FileUploader } from 'ng2-file-upload';
import { eventType, ThemeColor } from '../class/eventType';
import { AppError } from '../common/class/app-error';
import { ProtectedReplyService } from '../service/protected-reply-service';

@Component({
  selector: 'app-protected-reply',
  templateUrl: './protected-reply.component.html',
  styleUrls: ['./protected-reply.component.scss']
})
export class ProtectedReplyComponent implements OnInit {


  @Input() msgdata: any;
  @Input() EsignReplyPopupOpen: any;
  @Input() ReplypopUpOpen: any;
  @Input() shortURL: any;
  @Input() colorTheme: any;
  @Output() dataEvent = new EventEmitter<string>();

  msgDetails = {
    from: "",
    to: "",
    subject: "",
    copyme: false
  }

  content = '';
  uploadProgress = 0;
  attachedFiles: any = [];
  selectedFiles: any = [];
  attachmentStrings: any = [];
  uploader: FileUploader;
  mbToByteMultiplier = 1048576;
  largeMailByteSize = 10485760;
  totalAttachmentSize = 0;
  uploadMaxSizeBytes = 100 * this.mbToByteMultiplier;
  rejectedFiles = [];
  oversizeFiles = [];
  characterCount = 0;
  themeColor = ThemeColor.UnDefined;
  filetoUpload: any = [];

  modules = {
    toolbar: [

      ['bold', 'italic', 'underline', 'strike'],

      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],

      [{ 'list': 'ordered' }, { 'list': 'bullet' }],

      [{ 'script': 'sub' }, { 'script': 'super' }],

      [{ 'indent': '-1' }, { 'indent': '+1' }],

      [{ 'direction': 'rtl' }],

      [{ 'size': ['small', false, 'large', 'huge'] }],

      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],

      [{ 'font': [] }],

      [{ 'align': [] }],

      ['clean']

    ]
  };

  constructor(private cdref: ChangeDetectorRef, private protectedService: ProtectedReplyService, private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {

    this.uploader = new FileUploader({});

  }

  ngOnInit() {

    if (this.msgdata != null && this.msgdata != '' && this.msgdata != undefined)
      this.translate.use(this.msgdata.DestinationDetails.MessageLanguage);

    this.themeColor = this.colorTheme == false ? ThemeColor.White : ThemeColor.Black;

    this.msgDetails = {
      from: this.msgdata.DestinationDetails.DestinationName != '' && this.msgdata.DestinationDetails.DestinationName != null && this.msgdata.DestinationDetails.DestinationName != undefined ? this.msgdata.DestinationDetails.DestinationName + '<' + this.msgdata.DestinationDetails.DestinationAddress + '>' : this.msgdata.DestinationDetails.DestinationAddress,
      to: this.msgdata.DestinationDetails.SenderAddress,
      subject: this.translate.instant('ReSubject') + this.msgdata.DestinationDetails.MessageSubject,
      copyme: this.msgdata.DestinationDetails
        .ProtectMsgReplyCopyMeEnabled || false
    }

    if (this.EsignReplyPopupOpen) {
      this.content = "I agree with the content of the e-mail, the contract and any attachment(s), and I further agree to use electronic signature and sign here.<br/> Type you name here:"
    }

  }

  sendProtectedReply() {

    if (this.characterCount > 50000) {
      this.showErrorToasterMsg("Reply character count exceeded maximum limit.");
      return;
    }
    if (this.msgdata.DestinationDetails.ProtectMsgReplyLimit <= 0) {

      //this.showErrorToasterMsg("Reply limit exceeded.");

      //return;
    }

    const protectSendEmailobj = {
      "SenderAddress": this.msgDetails.from,
      "Recipient": this.msgDetails.to,
      "Subject": this.msgDetails.subject,
      "Sender": this.msgDetails.from,
      "DestinationId": this.msgdata.DestinationDetails.DestinationId,
      "OriginalMessageId": this.msgdata.DestinationDetails.MessageId,
      "MessageBody": this.content,
      "CopySender": this.msgDetails.copyme,
      "Attachments": this.attachmentStrings,
      "IsLargeMail": this.totalAttachmentSize > this.largeMailByteSize,
      "IsProtectedReply": 1,
      "ReplyType": this.EsignReplyPopupOpen ? 2 : 1,
      "ShortURL": this.shortURL
    }

    this.protectedService.sendProtectedEmail(protectSendEmailobj).subscribe((resp: any) => {

      if (resp instanceof AppError) {
        this.dataEvent.emit(eventType.ErrorReply.toString());
      }
      else {

        this.showSuccessToasterMsg(resp.Message);
        //setTimeout(() => {
        //   window.location.href = this.msgdata.DestinationDetails.ProtectMsgReplyLandingPage != '' &&
        //     this.msgdata.DestinationDetails.ProtectMsgReplyLandingPage != null
        //     && this.msgdata.DestinationDetails.ProtectMsgReplyLandingPage != undefined ?
        //     this.msgdata.DestinationDetails.ProtectMsgReplyLandingPage:
        //   "https://rmail.com";
        // }, 5000);
        //}
        if (this.ReplypopUpOpen)
          this.dataEvent.emit(eventType.SuccessProtectedReply.toString());
        if (this.EsignReplyPopupOpen)
          this.dataEvent.emit(eventType.SuccessEsignReply.toString());
      }

    });

  }

  fileDrop(event: any) {

    for (let i = 0; i < event.length; i++) {
      const fileData = event[i];
      this.fileSizeChecking(fileData);
      const sizecheck = this.fileSizeChecking(fileData);

      if (!sizecheck)
        break;

      if (sizecheck && this.filetoUpload.length > 0)
        this.fileUpload(fileData);
    }
  }

  fileSelected(event: any) {

    for (let i = 0; i < event.length; i++) {

      let fileData = event[i];

      this.selectedFiles.push(fileData.name!);
      const sizecheck = this.fileSizeChecking(fileData);

      if (!sizecheck)
        break;

      if (sizecheck && this.filetoUpload.length > 0)
        this.fileUpload(fileData);

    }
  }

  fileSizeChecking(fileData: any) {

    let underLimit = true;

    let fileExt = fileData.name.toLowerCase().split(".").pop();
    const uploadedFileSize = this.totalAttachmentSize + fileData.size;
    this.totalAttachmentSize = uploadedFileSize;
    //const newFileSizeCount = this.fileSizeCount() + uploadedFileSize;

    if (fileData.size > this.uploadMaxSizeBytes) {
      const fileSizeString = `${this.getFileSizeString(this.uploadMaxSizeBytes)} `;
      const msg = `${this.translate.instant('SR_ATTACHMENT_EXCEEDS_MAXSIZE').replace('{fs}', fileSizeString)}`
      this.showErrorToasterMsg(msg);
      return false;
    } else if (fileData.size == 0) { //  || this.largemailFileTypes.indexOf(fileExt) < 0) {
      const fileSizeString = `${this.translate.instant('uploader')}, ${fileData.name}`;
      const msg = `${this.translate.instant('SR_BAD_ATTACHMENT')}`;
      this.showErrorToasterMsg(msg);
      return false;
    }
    else if (this.totalAttachmentSize > this.uploadMaxSizeBytes) {
      const fileSizeString = this.getFileSizeString(this.uploadMaxSizeBytes);
      const translatedMessage = this.translate.instant('SR_ATTACHMENT_EXCEEDS_MAXSIZE').replace('{fs}', fileSizeString);
      this.showErrorToasterMsg(translatedMessage);
      return false;
    }
    else if (this.totalAttachmentSize > this.largeMailByteSize && this.totalAttachmentSize < this.uploadMaxSizeBytes) {
      const msg = this.translate.instant('SR_LARGEMAIL_ATTACHMENTS');
      this.showErrorToasterMsg(msg);
      this.filetoUpload.push(fileData);
      return true;
    }
    else {
      this.filetoUpload.push(fileData);
      return true;
    }

  }

  fileUpload(file: any) {

    this.protectedService.uploadFile(file).subscribe(event => {
      this.uploadProgress = 0;
      if (event.type === HttpEventType.UploadProgress) {

        this.uploadProgress = Math.round(
          100 * event.loaded / event.total!
        );

      } else if (event instanceof HttpResponse) {
        this.showSuccessToasterMsg("Attachments uploaded successfully");
        this.attachmentStrings.push(event.body!);
        this.attachedFiles.push({
          fileName: file.name,
          fileId: event.body
        });
        this.uploadProgress = 0;
      }
    },
      error => {
        console.error(error);
      }
    );



  }

  removeFile(fileDet: any, index: any) {
    this.attachmentStrings.splice(index, 1);
    this.attachedFiles.splice(index, 1);
    this.uploadProgress = 0;
  }

  onContentChanged(event: any) {
    const edtr = event.editor;

    this.characterCount = edtr.getLength() - 1;
  }

  getFileSizeString(bytes: number) {
    var MB = bytes / (1024 * 1024);
    var GB = bytes / (1024 * 1024 * 1024);

    if (GB >= 1) {
      return GB.toFixed(0) + ' GB';
    } else {
      return MB.toFixed(0) + ' MB';
    }
  }

  closePopup() {
    this.dataEvent.emit(eventType.PopUpCLose.toString());
  }

  showSuccessToasterMsg(msg: string) {

    this.snackBar.open(msg, 'Close', {
      duration: 3000,
      //horizontalPosition: 'right',
      //verticalPosition: 'top',
      panelClass: ['success-snackbar', 'snack']
    });
  }

  showErrorToasterMsg(message: string) {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      //horizontalPosition: 'right',
      //verticalPosition: 'top',
      panelClass: ['error-snackbar', 'snack']
    });
  }


}
